import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Button, Card, Col, Divider, Modal, notification, Row, Table } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

import VouchersQuery from '../../components/Query/Vouchers';
import VoucherDetail from './VoucherDetail';
import { Title } from '../../components/Layout/components';

interface IVouchersTableState {
  voucher?: GQL.IVoucher;
}

interface IVouchersTableProps extends RouteComponentProps<{ eshop: string; voucherGroup: string }> {
  page: number;
  limit: number;
}

export default class VouchersTable extends React.Component<IVouchersTableProps, IVouchersTableState> {

  public componentDidMount() {
    if ((this.props as any).onCollapse) {
      (this.props as any).onCollapse(false);
    }
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <VouchersQuery voucherGroupId={this.props.match.params.voucherGroup}>
            {({ vouchers, deleteVoucher, createVoucher, updateVoucher }: any) => {
              return this.renderData(
                vouchers,
                updateVoucher,
                createVoucher,
                deleteVoucher,
                vouchers.refetch
              );
            }}
          </VouchersQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    vouchers: any,
    updateVoucher: Function,
    createVoucher: Function,
    deleteVoucher: Function,
    refetch: Function
  ) {
    const { eshop, voucherGroup } = this.props.match.params;
    
    if (vouchers) {
      const showAmountValueColumn = vouchers && vouchers.vouchers && vouchers.vouchers.some((v: GQL.IVoucher) => (
        Array.isArray(v.amountValue) && v.amountValue.some(av => (('number' === typeof av.priceWithout) && (av.priceWithout > 0)))
      ));
      return (
        <div>
          <Title>Vouchers - {vouchers.voucherGroup && vouchers.voucherGroup.title}</Title>
          <Divider />
          <Link to={`/${this.props.match.params.eshop}/application/vouchers`} className={'ant-btn'}>
            Back to voucher groups
          </Link>
          <Divider type={'vertical'} />
          <Button onClick={() => this.newVoucher()}>Create new voucher</Button>
          <Divider type={'vertical'} />
          <Link to={`/${eshop}/application/import-export-vouchers/${voucherGroup}`} className={'ant-btn'}>
            Import / Export vouchers
          </Link>
          <Divider type={'vertical'} />
          <Link to={`/${eshop}/application/generate-random-vouchers/${voucherGroup}`} className={'ant-btn'}>
            Generate random vouchers
          </Link>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={vouchers.vouchers}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column
              title="Voucher code"
              dataIndex="title"
              key="title"
            />
            <Table.Column
              title="Pohoda IDS"
              dataIndex="pohodaIDS"
              key="pohodaIDS"
            />
            <Table.Column
              width={120}
              title="Usage"
              key="usage"
              render={(u: any, row: GQL.IVoucher) => (
                <span>
                  {row.actualUsage} / {row.usageLimit}
                </span>
              )}
              align="center"
            />
            <Table.Column
              title="Valid from"
              width={140}
              dataIndex="validFrom"
              key="validFrom"
              align="center"
            />
            <Table.Column
              title="Valid to"
              width={140}
              dataIndex="validTo"
              key="validTo"
              align="center"
            />
            <Table.Column
              title="Active"
              width={100}
              dataIndex="active"
              key="active"
              render={(u, row: GQL.IVoucher) => {
                return (
                  <span>
                    {row.active 
                      ? <CheckOutlined style={{ color: '#52c41a', fontSize: 20 }} />
                      : <CloseOutlined style={{ fontSize: 20 }} />}
                  </span>
                );
              }}
              align="center"
            />
            {showAmountValueColumn && <Table.Column
              title="Amount Value"
              width={140}
              dataIndex="amountValue"
              key="amountValue"
              align="right"
              render={(u, row: GQL.IVoucher) => {
                if (!Array.isArray(row.amountValue)) {
                  return ''; 
                }
                return (<span>
                  {row.amountValue.map((av, i) => av && ('number' === typeof av.priceWithout) && (av.priceWithout > 0)
                    && <div key={`${av.currencyCode}-${i}`}>{`${av.priceWithout} ${av.currencyCode}`}</div>
                    || '')}
                </span>);
              }}
            /> || ''}
            <Table.Column
              width={190}
              title="Actions"
              dataIndex="actions"
              key="actions"
              align="center"
              render={(u: any, row: any) => this.renderActions(u, row, deleteVoucher, refetch)}
            />
          </Table>
          {this.state &&
            this.state.voucher && (
              <VoucherDetail
                voucher={this.state.voucher}
                onSave={a => this.upsert(a, updateVoucher, createVoucher, refetch)}
                onCancel={() => this.setCurrentVoucher(undefined)}
                domain={this.props.match.params.eshop}
              />
            )}
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading vouchers ..." style={{ width: '100%' }} />
      </div>
    );
  }

  private renderActions(u: any, voucher: GQL.IVoucher, deleteVoucher: Function, refetch: Function) {
    return (
      <div>
        <Button type={'dashed'} onClick={() => this.setCurrentVoucher(voucher)}>
          Edit
        </Button>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(voucher, deleteVoucher, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private newVoucher(category?: any) {
    this.setCurrentVoucher({});
  }

  private setCurrentVoucher(voucher: any) {
    this.setState({ voucher });
  }

  private delete(voucher: GQL.IVoucher, deleteVoucher: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete ${voucher.title}?`,
      content: (
        <span>
          Are you sure you want to delete voucher <strong>{voucher.title}</strong>?
        </span>
      ),
      onOk: () => {
        return deleteVoucher({
          variables: {
            id: voucher.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(voucher: GQL.IVoucher, updateVoucher: Function, createVoucher: Function, refetch: Function) {
    if (voucher != undefined) {
      // někdy je .priceWithout jako string
      voucher.amountValue = Array.isArray(voucher.amountValue) ? voucher.amountValue.map((av) => {
        if (av && ('string' === typeof av.priceWithout)) {
          const price = parseFloat(av.priceWithout);
          if (!isNaN(price) && voucher && voucher.amountValue) {
            return {...av, priceWithout: price}
          } else {
            return {...av, priceWithout: null};
          }
        }

        if (av && ('number' === typeof av.priceWithout)) {
          if (av.priceWithout > 0) {
            return av;
          } else {
            return {...av, priceWithout: null};
          }
        }
        return av;
      }).filter(av => av) : undefined;

      const variables = {
        id: voucher.id,
        voucherGroupId: this.props.match.params.voucherGroup,
        voucher: {
          title: voucher.title,
          pohodaIDS: voucher.pohodaIDS,
          active: voucher.active,
          usageLimit: voucher.usageLimit,
          validFrom: voucher.validFrom,
          validTo: voucher.validTo,
          amountValue: (Array.isArray(voucher.amountValue) && (voucher.amountValue.length > 0)) ? ((amountValue) => {
            let isValue: boolean = false;
            for (const oneValue of amountValue) {
              if (oneValue && ('number' === typeof oneValue.priceWithout) && (oneValue.priceWithout > 0)){
                isValue = true;
              }
            }
            if (isValue) {
              return amountValue;
            }
            return undefined;
          })(voucher.amountValue): undefined,
          customerId: ('string' === typeof voucher.customerId) ? voucher.customerId : undefined,
        }
      };

      if (voucher.id) {
        return updateVoucher({ variables })
          .then(() => this.setCurrentVoucher(null))
          .then(() => refetch())
          .then(() =>
            notification['success']({
              message: 'Info',
              description: `Voucher "${variables.voucher.title}" has been updated.`
            })
          );
      }

      createVoucher({ variables })
        .then(() => this.setCurrentVoucher(null))
        .then(() => refetch())
        .then(() =>
          notification['success']({
            message: 'Info',
            description: `Voucher "${variables.voucher.title}" has been created.`
          })
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Vouchers/VoucherTable.tsx